import { ViewAction, ViewActionConfig } from '@antony/ng-ui';
import { FullscreenToggleService } from '../fullscreen-toggle.service';
import { inject } from '@angular/core';

export abstract class FullscreenViewAction extends ViewAction<undefined> {
  protected readonly fullScreenService = inject(FullscreenToggleService);

  getConfig(): ViewActionConfig {
    return {
      ...super.getConfig(),
      hideLabel: true,
      color: 'primary',
    };
  }
}
